import React from 'react';

import { cssMap } from '@atlaskit/css';
import PlaylistIcon from '@atlaskit/icon-lab/core/playlist';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	container: {
		alignItems: 'center',
		backgroundColor: token('color.background.neutral'),
		borderRadius: token('radius.medium'),
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		width: '100%',
	},
});

export const LoomPlaylistIcon = (): React.JSX.Element => (
	<Box testId="loom-playlist-icon" xcss={styles.container}>
		<PlaylistIcon label="" color={token('color.text.accent.green')} size="small" spacing="none" />
	</Box>
);
